import { SettingKey } from 'src/constants';
import { useSettingContext } from 'src/contexts/setting.context';

export const useSetting = (key: SettingKey, defaultValue: any = ''): any => {
  const { state } = useSettingContext();

  return state.listByKey[key] !== undefined
    ? state.listByKey[key]
    : defaultValue;
};

export const useSettings = <T extends SettingKey[]>(keys: T) => {
  const { state } = useSettingContext();

  return keys.reduce(
    (items, key) => ({
      ...items,
      [key]: state.listByKey[key] !== undefined ? state.listByKey[key] : '',
    }),
    {}
  ) as Record<T[number], any>;
};
